<div class="select-behalf-org-container col">
  <h1 class="dialog-title">Create Job On Behalf</h1>

  <form [formGroup]="behalfForm" (ngSubmit)="save()" class="form-container col">
    <!-- Radio Group for Organization Type -->
    <div class="org-type-selection row space-btw ai-c">
      <div class="radio-option" (click)="behalfForm.patchValue({ organizationType: 'partner' })">
        <div class="radio-wrapper row ha-c ai-c">
          <div class="hmt-radio-button flex ai-c ha-c"
            [class.active]="behalfForm.get('organizationType')?.value === 'partner'">
            <div class="radio-circle" [class.active]="behalfForm.get('organizationType')?.value === 'partner'"></div>
          </div>
          <label class="radio-label">Partner Organisation</label>
        </div>
      </div>

      <div class="radio-option" (click)="behalfForm.patchValue({ organizationType: 'onboarded' })">
        <div class="radio-wrapper row ha-c ai-c">
          <div class="hmt-radio-button flex ai-c ha-c"
            [class.active]="behalfForm.get('organizationType')?.value === 'onboarded'">
            <div class="radio-circle" [class.active]="behalfForm.get('organizationType')?.value === 'onboarded'"></div>
          </div>
          <label class="radio-label">Onboarded Organisation</label>
        </div>
      </div>
    </div>

    <!-- Organization Selection with Search -->
    <div class="org-selection-wrapper">
      <label class="field-label">Select Organisation</label>
      <mat-form-field appearance="outline" class="hmt-form-field org-select-field">
        <input type="text" matInput formControlName="organization" 
          placeholder="Type to search or select organisation"
          [matAutocomplete]="organizationAutoComplete" 
          aria-label="Select Organisation"
          (input)="onSearchInput($event)">
        <mat-icon matIconPrefix class="search-icon">search</mat-icon>
        <mat-icon matIconSuffix class="dropdown-icon">arrow_drop_down</mat-icon>
        <mat-autocomplete #organizationAutoComplete="matAutocomplete" 
          [displayWith]="displayWithOrganization"
          class="scrollable-autocomplete">
          <mat-option *ngFor="let org of availableOrganizations" [value]="org">
            {{ org.orgName }}
          </mat-option>
          
          <!-- Load More Option -->
          <mat-option *ngIf="hasMoreData && !loading" [value]="null" (click)="onScroll()" class="load-more-option">
            <div class="load-more-text">Load More...</div>
          </mat-option>
          
          <!-- Loading Indicator -->
          <mat-option *ngIf="loading" [value]="null" disabled class="loading-option">
            <div class="loading-text row ai-c ha-c">
              <mat-spinner diameter="20"></mat-spinner>
              <span style="margin-left: 8px;">Loading...</span>
            </div>
          </mat-option>
          
          <!-- No Results -->
          <mat-option *ngIf="!loading && availableOrganizations.length === 0" [value]="null" disabled>
            <div class="no-results-text">No organizations found</div>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <!-- Save Button -->
    <div class="action-wrapper row ai-c ha-e">
      <button type="submit" class="hmt-action-button save-btn" [disabled]="!behalfForm.valid">
        Save
      </button>
    </div>
  </form>
</div>